import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import './SolicitacaoCadastroArquivosGrandesVolumes.css';
import { SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory } from "./AttachmentsAndHistory";
import { ArquivoGrandesVolumesDetails } from "./Details";
import { ConfirmationModal } from "../UI/ConfirmationModal/ConfirmationModal";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const SolicitacaoArquivoGrandesVolumesApproval =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					id: undefined,
					cedenteDosDados: undefined,
					esferasAdministrativas: [],
					cpfDirigenteTi: '',
					cpfResponsavelTecnico: '',
					titulo: "",
					descricao: "",
					arquivos: [],
					justificativaOrgaoAdministrador: '',
				},
				executouCarregamento: false,
				botoesHabilitados: true,
				exibeModalConfirmacao: false,
				msgModal: '',
				operacao: null,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.aprovarSolicitacao = this.aprovarSolicitacao.bind(this);
			this.rejeitarSolicitacao = this.rejeitarSolicitacao.bind(this);
			this.validaRejeicao = this.validaRejeicao.bind(this);	
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			this.props.mostraAguardando();

			api.get(`/api/solicitacao-cadastro-arquivo-gv/${id}`)
				.then(response => { 
					const solicitacao = response.data;
					this.setState({ solicitacao, executouCarregamento: true }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar a solicitação de adesão.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.props.escondeAguardando();
				});
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Cadastro de Arquivo Grandes Volumes</h1>
					</div>
					<div className="div-form">
						{this.state.executouCarregamento && this.renderForm()}
					</div>
				</main>
			);
		}

		renderForm() {
			const user = this.props.user;
			const solicitacao = this.state.solicitacao;

			return(
				<div className="container-fluid">
					
					<ConfirmationModal
						isOpen={this.state.exibeModalConfirmacao}
						onClose={() => this.fechaModal()}
						onConfirm={() => this.executaOperacao()}
						message={this.state.msgModal}
					/>

					<ArquivoGrandesVolumesDetails solicitacao={solicitacao} mostraDetalhesAprovacao={false}/>
					
					 <div className="br-form">
						<div className="row">
							{user.isAdministrador && 
								<div className="col-md">  
									<div className="field">
										<div className="input"> 
											<label htmlFor="justificativaOrgaoAdministrador">Justificativa conecta:</label>
											<textarea name="justificativaOrgaoAdministrador" value={solicitacao.justificativaOrgaoAdministrador} 
											onChange={this.handleInputChange} maxLength={500} style={{height:"90px"}}
											readOnly={! solicitacao.aprovacaoAdministradorPermitida}/>
										</div>
									</div>
								</div>
							}
						</div> 

						<SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory solicitacao={solicitacao} habilitaEdicaoAnexo={true}/>

						<div className="actions-button">
							<div className="actions justify-content-start">
								{solicitacao.aprovacaoAdministradorPermitida && 
									<Fragment>
										<button type="button" className="button is-primary" onClick={() => this.confirmaOperacao(this.aprovarSolicitacao, "Deseja realmente aprovar a solicitação de cadastro de arquivo de grandes volumes?")}  disabled={!this.state.botoesHabilitados}>Aprovar</button>
										<button type="button" className="button is-secondary" onClick={() => this.confirmaOperacao(this.rejeitarSolicitacao, "Deseja realmente rejeitar a solicitação de cadastro de arquivo de grandes volumes?", this.validaRejeicao)}  disabled={!this.state.botoesHabilitados}>Rejeitar</button>
									</Fragment>
								}
								<ButtonBack disabled={!this.state.botoesHabilitados} />								
							</div>
						</div>
					</div> 
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao });
		}

		handleInputNumberChange(nomePropriedade, valoresInput){
			const solicitacao = this.state.solicitacao;
			solicitacao[nomePropriedade] = Number(valoresInput.value);
			this.setState({ solicitacao });
		}
	
		confirmaOperacao(operacao, msgModal, validacao) {
			if(validacao) {
				try{
					validacao();
				}catch(erroValidacao){
					return;
				}
			}

			this.setState(
				{
					exibeModalConfirmacao: true,
					operacao,
					msgModal,
				}
			);
		}

		executaOperacao () {
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			this.state.operacao();
			this.fechaModal();
		}

		executaAndamento (url, mensagemSucesso, mensagemErro) {
			const { solicitacao } = this.state;
			const { id, justificativaOrgaoFornecedor, justificativaOrgaoAdministrador, volumetriaAutorizada } = solicitacao;

			const options = {
				method: 'put',
				url,
				data: { id, justificativaOrgaoFornecedor, justificativaOrgaoAdministrador, volumetriaAutorizada },
			}

			api(options)
				.then(response => { 
					this.setState({
						solicitacao: response.data,
						pesquisaExecutada : true,
					}) 
					this.props.exibeMensagemSucesso(mensagemSucesso);
				})
				.catch(erro => {
					const msg = getMessagemErro(mensagemErro, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		aprovarSolicitacao () {
			const mensagemSucesso = "Solicitação de adesão aprovada com sucesso.";
			const mensagemErro = "Não foi possível aprovar a solicitação de adesão.";
			const url = '/api/solicitacao-cadastro-arquivo-gv/deferir';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		rejeitarSolicitacao() {
			const mensagemSucesso = "Solicitação de adesão rejeitada com sucesso.";
			const mensagemErro = "Não foi possível rejeitar a solicitação de adesão.";
			const url = '/api/solicitacao-cadastro-arquivo-gv/rejeitar-administrador';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		validaRejeicao(){
					const { solicitacao } = this.state;
					const { justificativaOrgaoAdministrador } = solicitacao;
		
					if(!justificativaOrgaoAdministrador || justificativaOrgaoAdministrador.trim().length === 0 ){
						this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", [{mensagem: "Justificativa conecta é obrigatória."}])
						throw new Error("Formulário não preenchido corretamente.");
					}
				}

		fechaModal () {
			this.setState(
				{
					exibeModalConfirmacao: false,
				}
			);
		}
	}

) // redux
); // router